import './abstract_section_view.coffee';# Added by Script 
Namespace('Monitoring.Reports.Executive')

class Monitoring.Reports.Executive.BrandNgramsView extends Monitoring.Reports.Executive.AbstractSectionView
  template: JST["backbone/templates/monitoring/reports/executive/brand_ngrams"]
  tagName: 'section'
  id: 'ngrams'

  render: ->
    sentiments = {
      pos: 
        description: "positive"
        tag: "sa_Positivo"
        ico: "plus"
        color: "green"
      neu: 
        description: "neutral"
        tag: "sa_Neutro"
        ico: "circle"
        color: "grey"
      neg: 
        description: "negative"
        tag: "sa_Negativo"
        ico: "minus"
        color: "red"
    }
    @$el.html(@template( 
      brand:@options.settings.accountLabel.description
      sentiments:sentiments
    ))
    @labels = [@options.settings.accountLabel].concat @options.settings.competitorsLabels
    @bindChartsReady(3)
    
    _.each(sentiments, (sentiment) =>
      @startJob(sentiment.tag)
    )
    return this

  startJob: (ngram_tag) ->
    job = new Monitoring.Methods.AsyncJob()
    
    divSelector = '#' + ngram_tag + ' .cloud'
    job.bind('completed', (response) => @addWordsCloud(response, divSelector))
    query = {
      ngrams_limit: 20
      date_from_ISO: @options.fromISO.toISOString()
      date_to_ISO: @options.toISO.toISOString()
      labels: @options.settings.accountLabel.codes
      tags: [ngram_tag]
    }
    job.start('words', query)